import { useThemeStore, type Theme } from "../../store/themeStore.js";
import { useTranslation } from "react-i18next";

export function ThemeSwitcher(): JSX.Element {
  const { theme, setTheme } = useThemeStore();
  const { t } = useTranslation();

  return (
    <label className="theme-switcher" title={t("theme.label")}>
      <span className="sr-only">{t("theme.label")}</span>
      <select
        value={theme}
        onChange={(e) => setTheme(e.target.value as Theme)}
        className="switcher-select"
      >
        <option value="light">{t("theme.light")}</option>
        <option value="dark">{t("theme.dark")}</option>
        <option value="system">{t("theme.system")}</option>
      </select>
    </label>
  );
}
